var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.domain.load_error
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "gg-card",
                    [
                      _c("gg-card-header", [_vm._v(" Error ")]),
                      _c("gg-card-text", [
                        _vm._v(" " + _vm._s(_vm.domain.load_error) + " ")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "gg-loading",
                    {
                      attrs: {
                        loading: !_vm.domainPopulated,
                        type: "card"
                      }
                    },
                    [
                      _c(
                        "gg-card",
                        [
                          _c("gg-card-header", [
                            _vm._v(" Nameserver Details ")
                          ]),
                          _c(
                            "gg-card-text",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    md: "4"
                                  }
                                },
                                [
                                  _c("gg-select", {
                                    attrs: {
                                      label: "Select preset",
                                      items: _vm.dns_presets,
                                      "item-text": "printableName",
                                      "item-value": "name",
                                      outlined: ""
                                    },
                                    model: {
                                      value: _vm.selected_preset,
                                      callback: function callback($$v) {
                                        _vm.selected_preset = $$v
                                      },
                                      expression: "selected_preset"
                                    }
                                  }),
                                  _c(
                                    "v-form",
                                    [
                                      _vm._l(_vm.dns_presets, function(
                                        item,
                                        key
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: key
                                          },
                                          [
                                            item.name === _vm.selected_preset
                                              ? _vm._l(item.servers, function(
                                                  server,
                                                  sub_key
                                                ) {
                                                  return _c("gg-text-field", {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: "ip_or_fqdn",
                                                        expression:
                                                          "'ip_or_fqdn'"
                                                      }
                                                    ],
                                                    key: sub_key,
                                                    attrs: {
                                                      outlined: "",
                                                      label: "Nameserver ".concat(
                                                        sub_key + 1
                                                      ),
                                                      value: server,
                                                      disabled: !_vm.isSelectedCustomPreset,
                                                      name: "Nameserver ".concat(
                                                        sub_key + 1
                                                      ),
                                                      "error-messages": _vm.errors.collect(
                                                        "Nameserver ".concat(
                                                          sub_key + 1
                                                        )
                                                      ),
                                                      "append-icon":
                                                        "mdi-trash-can-outline"
                                                    },
                                                    on: {
                                                      "click:append": function clickAppend(
                                                        $event
                                                      ) {
                                                        return _vm.removeField(
                                                          sub_key
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value:
                                                        item.servers[sub_key],
                                                      callback: function callback(
                                                        $$v
                                                      ) {
                                                        _vm.$set(
                                                          item.servers,
                                                          sub_key,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "item.servers[sub_key]"
                                                    }
                                                  })
                                                })
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      }),
                                      _vm.canAddNameserver
                                        ? _c(
                                            "gg-btn",
                                            {
                                              staticClass: "mr-4",
                                              attrs: {
                                                secondary: ""
                                              },
                                              on: {
                                                click: _vm.addField
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " Add additional nameserver "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "gg-btn",
                                        {
                                          staticClass: "mr-2",
                                          attrs: {
                                            loading: _vm.buttons.save_ns
                                          },
                                          on: {
                                            click: _vm.saveNS
                                          }
                                        },
                                        [_vm._v(" Save changes ")]
                                      )
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.isHostedSelected
                ? _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c("name-servers-editor", {
                        attrs: {
                          domainid: _vm.domainid,
                          domain: _vm.domain.domain
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isCustomNSAvailable
                ? _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [_c("name-servers-registration")],
                    1
                  )
                : _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c(
                        "gg-card",
                        [
                          _c("gg-card-header", [
                            _vm._v(" Nameserver Registration ")
                          ]),
                          _c("gg-card-text", [
                            _c(
                              "p",
                              {
                                staticClass: "body-1"
                              },
                              [
                                _vm._v(
                                  " Your domain requires special nameserver registration steps. Please contact Support for assistance with registering nameservers. "
                                )
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }